import AngelistFormContainer from './angelist_form_container';

const AngelistForm = AngelistFormContainer;
export default AngelistForm;
